import cloudServiceModule from '../cloudService.module';

class AccountApiService {
    constructor($http, __env, $q) {
        this.$http = $http;
        this.__env = __env;
        this.$q = $q;
        this.promiseCache = {};
    }

    constructCacheablePromise(promiseId, event) {
        if (this.promiseCache[promiseId]) {
            return this.promiseCache[promiseId].promise;
        }
        var deferred = this.$q.defer();
        this.promiseCache[promiseId] = deferred;
        event(deferred).finally(() => delete this.promiseCache[promiseId]);
        return deferred.promise;
    }

    getSubscriptionEntitlement(accountGuid) {
        return this.constructCacheablePromise(
            `getSubscriptionEntitlement${accountGuid}`,
            deferred => {
                return this.$http
                    .get(
                        `${
                            this.__env.cloudApiUrl
                        }/api/v2/accounts/${accountGuid}/entitlement`
                    )
                    .then(
                        response => deferred.resolve(response.data),
                        response => deferred.reject(response.data)
                    );
            }
        );
    }

    getPlanInformation(accountGuid) {
        return this.constructCacheablePromise(
            `getPlanInformation${accountGuid}`,
            deferred => {
                return this.$http
                    .get(
                        `${
                            this.__env.cloudApiUrl
                        }/api/v2/accounts/${accountGuid}/plan`
                    )
                    .then(
                        response => deferred.resolve(response.data),
                        response => deferred.reject(response.data)
                    );
            }
        );
    }

    getBillingInformation(accountGuid) {
        return this.constructCacheablePromise(
            `getBillingInformation${accountGuid}`,
            deferred => {
                return this.$http
                    .get(
                        `${
                            this.__env.cloudApiUrl
                        }/api/v2/accounts/${accountGuid}/billing`
                    )
                    .then(
                        response => deferred.resolve(response.data),
                        response => deferred.reject(response.data)
                    );
            }
        );
    }

    getUsersOfAccount(accountGuid, search, userType) {
        var deferred = this.$q.defer();
        this.$http
            .get(
                `${
                    this.__env.cloudApiUrl
                }/api/v2/accounts/${accountGuid}/users`,
                {
                    params: {
                        search: search,
                        userType: userType
                    }
                }
            )
            .then(
                response => deferred.resolve(response.data),
                response => deferred.reject(response.data)
            );
        return deferred.promise;
    }

    getAccountInfo(cloudToken, accountGuid) {
        return this.constructCacheablePromise(
            `getAccountInfo${accountGuid}`,
            deferred => {
                return this.$http
                    .get(
                        `${
                            this.__env.cloudApiUrl
                        }/api/v1/appspace/accounts/${accountGuid}`,
                        {
                            headers: {
                                token: cloudToken
                            }
                        }
                    )
                    .then(
                        response => deferred.resolve(response.data),
                        response => deferred.reject(response.data)
                    );
            }
        );
    }
}

export default cloudServiceModule.service(
    'accountApiService',
    AccountApiService
);



// WEBPACK FOOTER //
// ./modules/cloudService/account/accountApi.service.js